const open = document.getElementById('popup-open');
const sizes_guide = document.getElementById('sizes-guide');
const close = document.getElementById('popup-close');
const productVol = document.querySelector('.product-sizes-section__size');
let productVolWid = 0;
let breakpointDesktop = window.matchMedia('(min-width: 961px)'); 
if(close) {
    if(breakpointDesktop.matches) {
        if(productVol) {
            productVolWid = productVol.getBoundingClientRect().width;
        }
        const sizeWid = document.querySelector('.product-sizes-section__button').getBoundingClientRect().width;
        const sizeContWid = document.querySelector('.sizes-guide').getBoundingClientRect().width;
        const sizeLeftVal = (sizeWid + productVolWid) - (sizeWid / 2);
        document.querySelector('.sizes-guide').style.left = `${(sizeContWid / -2) + sizeLeftVal}px`;
    }
}

if(open)open.addEventListener('click', () => {
    sizes_guide.classList.add('show');
});
if(close)close.addEventListener('click', () => {
    sizes_guide.classList.remove('show');
});

const productDescriptionOuter = document.querySelector('.product__description__outer');
const productDescriptionToggle = document.querySelector('.product__description__toggle');


if(productDescriptionToggle)productDescriptionToggle.addEventListener('click', () => {
    if(productDescriptionOuter.classList.contains("show")){
        productDescriptionOuter.classList.remove('show');
    }else {
        productDescriptionOuter.classList.add('show');
    }
});